import { render } from "./MensajeValidacion.vue?vue&type=template&id=6384d362"
import script from "./MensajeValidacion.vue?vue&type=script&lang=js"
export * from "./MensajeValidacion.vue?vue&type=script&lang=js"

import "./MensajeValidacion.vue?vue&type=style&index=0&id=6384d362&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.29_vue@3.5.29_webpack@4.47.0_supports-color@6.1.0_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__